// extracted by mini-css-extract-plugin
export default {"benefits":"Benefits_benefits__X7HN8","activities_icons_image":"Benefits_activities_icons_image__Uti6A","user_image":"Benefits_user_image__Ce4D+"};